module.exports = __webpack_public_path__ + "img/signal_cellular_1_bar-black.9be19458.svg";